import { Controller } from 'stimulus'

// By sample's List (app/views/mobile/tasks/_enter_sample): a sheet with every
// result row, its samples, label, status, and comment. The rows load the
// first time the sheet opens (TasksController#samples); search and the filters
// (All, each status the rows have, Has a comment) then run on the phone.
// Tapping a row opens it.
export default class extends Controller {
  static targets = ['sheet', 'list', 'query', 'filter', 'empty']

  connect() {
    this.loaded = false
    this.loading = false
    this.status = 'all'
    this.onKey = this.onKey.bind(this)
  }

  disconnect() {
    this.unlock()
  }

  open() {
    this.sheetTarget.hidden = false
    document.body.classList.add('mb-sheet-open')
    document.addEventListener('keydown', this.onKey)
    if (this.loaded) {
      this.showCurrent()
    } else {
      this.load()
    }
  }

  close() {
    this.sheetTarget.hidden = true
    this.unlock()
  }

  unlock() {
    document.body.classList.remove('mb-sheet-open')
    document.removeEventListener('keydown', this.onKey)
  }

  onKey(event) {
    if (event.key === 'Escape') this.close()
  }

  load() {
    if (this.loading) return

    this.loading = true
    // redirect: 'manual': signed out or no longer allowed answers with a
    // redirect, which must show the error note, not that page in the sheet.
    fetch(this.data.get('url'), { credentials: 'same-origin', headers: { Accept: 'text/html' }, redirect: 'manual' })
      .then((response) => {
        if (!response.ok) throw new Error(response.status)
        return response.text()
      })
      .then((html) => {
        this.listTarget.innerHTML = html
        this.loaded = true
        this.recount()
        this.filter()
        this.showCurrent()
      })
      .catch(() => {
        this.listTarget.innerHTML = '<p class="mb-sheet-note">The samples didn\'t load. Close the list and open it again.</p>'
      })
      .finally(() => { this.loading = false })
  }

  pick(event) {
    this.status = event.currentTarget.dataset.status
    this.filterTargets.forEach(button => button.setAttribute('aria-pressed', String(button === event.currentTarget)))
    this.filter()
  }

  filter() {
    if (!this.loaded) return

    const query = this.queryTarget.value.trim().toLowerCase()
    let shown = 0
    Array.from(this.listTarget.querySelectorAll('[data-search]')).forEach((row) => {
      const match = (!query || row.dataset.search.includes(query)) && this.matchesFilter(row)
      row.toggleAttribute('hidden', !match)
      if (match) shown += 1
    })
    this.emptyTarget.hidden = shown > 0
  }

  // All; a status; or 'comment' (rows with a comment).
  matchesFilter(row, key = this.status) {
    if (key === 'all') return true
    if (key === 'comment') return row.dataset.comment === '1'
    return row.dataset.status === key
  }

  // The filters' counts came with the page; the rows are newer (a comment or
  // status saved since), so count again from them.
  recount() {
    const rows = Array.from(this.listTarget.querySelectorAll('[data-search]'))
    this.filterTargets.forEach((button) => {
      const count = button.querySelector('small')
      if (count) count.textContent = rows.filter(row => this.matchesFilter(row, button.dataset.status)).length
    })
  }

  showCurrent() {
    const current = this.listTarget.querySelector('.is-current')
    if (current && !current.hidden) current.scrollIntoView({ block: 'center' })
  }
}
